import { render, staticRenderFns } from "./TreeChart.vue?vue&type=template&id=de43c63c&scoped=true"
import script from "./TreeChart.vue?vue&type=script&lang=js"
export * from "./TreeChart.vue?vue&type=script&lang=js"
import style0 from "./TreeChart.vue?vue&type=style&index=0&id=de43c63c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de43c63c",
  null
  
)

export default component.exports